<template>
  <div class="form-group" :class="{ 'has-error': errors.has(name), 'form-group-active': active }">
    <label
      class="control-label"
      v-if="label">
      {{ label }}
    </label>
    <input
      ref="input"
      class="form-control"
      type="text"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      :data-vv-as="label"
      :required="required"
      v-mask="'###.###.###-##'"
      masked="true"
      v-validate="{ required: required, cpf: true }"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value),changeFocus()"
      @focus="changeFocus()"
    />
    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>

<script>
import CPF from "cpf";

export default {
  inject: ["$validator"],
  name: "form-group-cpf",
  props: {
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: String
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  created() {
    this.$validator.extend("cpf", {
      getMessage: "O CPF informado é inválido",
      validate: value => {
        return CPF.isValid(value);
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupCpf.vue